export default "__VITE_ASSET__2gqGk$lP__"